import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-eeb81768"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-justify-between" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-download p-ml-3" }, null, -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "p-d-flex p-align-center p-justify-between" }

import { computed, ref } from "vue";
import { isNumber } from "chart.js/helpers";
import { numberSeparators, toDate } from "@/graphql/utils/utils";
import { activeActivity, subscriptionExpired } from "@/plugins/i18n";
import { createMultiProducts } from "@/graphql/product/create.multi-products";
import { usePriceHelper } from "@/components/product/price-helper";
import ImportationError from "@/components/product/ImportationError.vue";
import { Category, EAccessMenu } from "@/graphql/types";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";

type ErrorKey = "inclTax" | "exclTax" | "vat";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCSV',
  props: {
    categories: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

const minDate = new Date();
const { _inclTax, _exclTax, _vat } = usePriceHelper();
const statistics = computed(() => ({
  import: `${rows.value.length}/${result.value.length}`,
  correction: errors.value.size,
}));
const canCreate = computed(() => {
  const acc = getAccess(EAccessMenu.Product);
  const noRestriction = canNavigateAnywhere();
  const expired = Boolean(subscriptionExpired());
  return (acc?.create || noRestriction) && !expired;
});
const {
  submitCreation,
  result,
  hasSelectedFile,
  errors,
  importationErrors,
  addImportationError,
  rows,
  addRow,
  removeRow,
  disableSubmit,
  loading,
} = createMultiProducts();

function onExclTaxChange(exclTax: number, index: number) {
  rows.value[index].exclTax = exclTax;
  if (rows.value[index].vat)
    rows.value[index].inclTax = _inclTax(rows.value[index].vat, exclTax);
  else
    rows.value[index].vat = _vat(
      rows.value[index].exclTax,
      rows.value[index].inclTax
    );
}
function onInclTaxChange(inclTax: number, index: number) {
  rows.value[index].inclTax = inclTax;
  if (rows.value[index].vat)
    rows.value[index].exclTax = _exclTax(rows.value[index].vat, inclTax);
  else
    rows.value[index].vat = _vat(
      rows.value[index].exclTax,
      rows.value[index].inclTax
    );
}
function onVatChange(vat: number, index: number) {
  rows.value[index].vat = vat;
  if (rows.value[index].exclTax)
    rows.value[index].inclTax = _inclTax(vat, rows.value[index].exclTax);
  else rows.value[index].exclTax = _exclTax(vat, rows.value[index].inclTax);
}

function getValue(val: string) {
  if (!val) val = "";
  val = val.replaceAll('"', "");
  val = val.replaceAll("\\r", "");
  return val.trim();
}
function getNumber(val: string) {
  val = getValue(val);
  return isNumber(val) ? Number(val) : 0;
}

function toFixed(value: number) {
  return Number(value.toFixed(activeActivity.value.decimalNumber));
}

function hasError(key: ErrorKey, index: number): string {
  return errors.value.has(key + index) ? "p-invalid" : "";
}

function addError(key: ErrorKey, index: number) {
  errors.value.add(key + index);
}

function loadInput() {
  rows.value.length = 0;
  errors.value.clear();
  result.value.forEach((prod, index) => {
    const values = prod.split(/[;,|]/);
    console.log(getValue(values[0]));
    const category = props.categories.find(
      (c) => c.label.toLowerCase() === getValue(values[0]).toLowerCase()
    );
    const reference = getValue(values[1]);
    const name = getValue(values[2]);
    if (category && reference && name) {
      //storable data
      let exclTax = getNumber(values[4]);
      let vat = getNumber(values[5]);
      let inclTax = getNumber(values[6]);
      //detect errors
      if (exclTax) {
        const realInclTax = _inclTax(vat, exclTax);
        if (inclTax && inclTax != toFixed(realInclTax))
          addError("inclTax", index);
        inclTax = realInclTax;
      } else if (inclTax) {
        const realExclTax = _exclTax(vat, inclTax);
        if (exclTax && exclTax != toFixed(realExclTax))
          addError("exclTax", index);
        exclTax = realExclTax;
      }

      rows.value.push({
        categoryId: category.id,
        reference,
        name,
        purchasePrice: getNumber(values[3]),
        exclTax,
        vat,
        inclTax,
        type: getNumber(values[7]) ? 0 : 1,
        quantity: getNumber(values[8]),
        expiredAt: toDate(getValue(values[9])),
        alertAt: toDate(getValue(values[10])),
        threshold: getNumber(values[11]),
      });
    } else addImportationError(index + 2, reference, name);
  });
}

function onFileChange(files: any[]) {
  if (!files.length) {
    hasSelectedFile.value = false;
    return;
  }
  hasSelectedFile.value = true;
  createInput(files[0]);
}

function createInput(file: any) {
  const reader = new FileReader();
  reader.onload = (e) => {
    const res = (e.target.result as string).split("\n");
    if (res.length) res.splice(0, 1);
    if (res[res.length - 1] === "") res.pop();
    result.value = res;
    loadInput();
  };
  reader.readAsText(file);
}

return (_ctx: any,_cache: any) => {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_FileUpload, {
        disabled: !canCreate.value,
        mode: "basic",
        accept: ".csv",
        onSelect: _cache[0] || (_cache[0] = ($event: any) => (onFileChange($event.files))),
        multiple: false,
        "show-upload-button": false,
        class: "p-inputgroup-addon",
        "choose-label": _ctx.$t('product.chooseCsv')
      }, null, 8, ["disabled", "choose-label"]),
      (_unref(hasSelectedFile))
        ? (_openBlock(), _createBlock(ImportationError, {
            key: 0,
            label: _ctx.$t('product.csvStatistics', { ...statistics.value }),
            errors: _unref(importationErrors)
          }, null, 8, ["label", "errors"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        class: "p-button p-button-warning p-inputgroup-addon",
        to: "/product_csv_model.csv",
        target: "_blank"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("product.downloadModel")) + " ", 1),
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_DataTable, {
      value: _unref(rows),
      scrollable: true,
      "scroll-height": "flex",
      style: {"height":"calc(100vh - 220px)"},
      class: "p-mt-3 p-datatable-sm",
      rows: _unref(rows).length,
      loading: _unref(loading)
    }, _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          style: {"width":"50px"},
          header: _ctx.$t('product.action')
        }, {
          body: _withCtx(({ index }) => [
            _createVNode(_component_Button, {
              style: {"width":"40px"},
              icon: "pi pi-trash",
              onClick: ($event: any) => (_unref(removeRow)(index)),
              class: "p-button-warning p-button-rounded"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "categoryId",
          header: _ctx.$t('product.category'),
          style: {"width":"200px"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Dropdown, {
              modelValue: data.categoryId,
              "onUpdate:modelValue": ($event: any) => ((data.categoryId) = $event),
              options: _ctx.categories,
              filter: true,
              optionLabel: "label",
              "filter-fields": ['label'],
              "scroll-height": "150px",
              "empty-filter-message": _ctx.$t('noResult'),
              id: "category",
              "data-key": "id",
              "option-value": "id",
              style: {"width":"200px"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "empty-filter-message"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          field: "reference",
          header: _ctx.$t('product.reference')
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              style: {"width":"100%"},
              modelValue: data.reference,
              "onUpdate:modelValue": ($event: any) => ((data.reference) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          field: "name",
          header: _ctx.$t('product.name')
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputText, {
              style: {"width":"100%"},
              modelValue: data.name,
              "onUpdate:modelValue": ($event: any) => ((data.name) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          field: "purchaseCost",
          header: _ctx.$t('product.purchaseCost')
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputNumber, {
              modelValue: data.purchasePrice,
              "onUpdate:modelValue": ($event: any) => ((data.purchasePrice) = $event),
              locale: _unref(numberSeparators)[_unref(activeActivity).separator],
              "max-fraction-digits": 20,
              "allow-empty": false,
              style: {"width":"100%"},
              min: 0,
              mode: "decimal"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "locale"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          header: _ctx.$t('product.exTax0')
        }, {
          body: _withCtx(({ data, index }) => [
            _createVNode(_component_InputNumber, {
              class: _normalizeClass(hasError('exclTax', index)),
              "model-value": data.exclTax,
              "allow-empty": false,
              locale: _unref(numberSeparators)[_unref(activeActivity).separator],
              "max-fraction-digits": 20,
              min: 0,
              style: {"width":"100%"},
              mode: "decimal",
              onInput: ($event: any) => (onExclTaxChange(Number($event.value), index))
            }, null, 8, ["class", "model-value", "locale", "onInput"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          header: _ctx.$t('product.vat')
        }, {
          body: _withCtx(({ data, index }) => [
            _createVNode(_component_InputNumber, {
              class: _normalizeClass(hasError('vat', index)),
              "model-value": data.vat,
              "allow-empty": false,
              style: {"width":"100%"},
              mode: "decimal",
              locale: _unref(numberSeparators)[_unref(activeActivity).separator],
              "max-fraction-digits": 20,
              min: 0,
              max: 100,
              onInput: ($event: any) => (
            onVatChange(
              Number($event.value) <= 100 ? $event.value : data.vat,
              index
            )
          )
            }, null, 8, ["class", "model-value", "locale", "onInput"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          header: _ctx.$t('product.inTax0')
        }, {
          body: _withCtx(({ data, index }) => [
            _createVNode(_component_InputNumber, {
              class: _normalizeClass(hasError('inclTax', index)),
              mode: "decimal",
              "allow-empty": false,
              locale: _unref(numberSeparators)[_unref(activeActivity).separator],
              "max-fraction-digits": 20,
              min: 0,
              "model-value": data.inclTax,
              style: {"width":"100%"},
              onInput: ($event: any) => (onInclTaxChange(Number($event.value), index))
            }, null, 8, ["class", "locale", "model-value", "onInput"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          header: _ctx.$t('product.storable')
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_InputSwitch, {
              modelValue: data.type,
              "onUpdate:modelValue": ($event: any) => ((data.type) = $event),
              "true-value": 0,
              "false-value": 1
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          field: "quantity",
          header: _ctx.$t('product.quantity')
        }, {
          body: _withCtx(({ data }) => [
            (data.type === 0)
              ? (_openBlock(), _createBlock(_component_InputNumber, {
                  key: 0,
                  modelValue: data.quantity,
                  "onUpdate:modelValue": ($event: any) => ((data.quantity) = $event),
                  locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                  "allow-empty": false,
                  "max-fraction-digits": 20,
                  min: 0,
                  style: {"width":"100%"},
                  mode: "decimal"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "locale"]))
              : (_openBlock(), _createElementBlock("label", _hoisted_3, "-"))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          header: _ctx.$t('product.expiredAt')
        }, {
          body: _withCtx(({ data }) => [
            (data.type === 0)
              ? (_openBlock(), _createBlock(_component_Calendar, {
                  key: 0,
                  modelValue: data.expiredAt,
                  "onUpdate:modelValue": ($event: any) => ((data.expiredAt) = $event),
                  dateFormat: _ctx.$t('format.calendarDate'),
                  placeholder: _ctx.$t('format.calendarDate'),
                  "year-navigator": true,
                  "min-date": _unref(minDate),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder", "min-date"]))
              : (_openBlock(), _createElementBlock("label", _hoisted_4, "-"))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"250px"},
          header: _ctx.$t('product.alertAt')
        }, {
          body: _withCtx(({ data }) => [
            (data.type === 0)
              ? (_openBlock(), _createBlock(_component_Calendar, {
                  key: 0,
                  modelValue: data.alertAt,
                  "onUpdate:modelValue": ($event: any) => ((data.alertAt) = $event),
                  dateFormat: _ctx.$t('format.calendarDate'),
                  placeholder: _ctx.$t('format.calendarDate'),
                  "year-navigator": true,
                  "min-date": _unref(minDate),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder", "min-date"]))
              : (_openBlock(), _createElementBlock("label", _hoisted_5, "-"))
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          style: {"min-width":"200px"},
          header: _ctx.$t('product.threshold')
        }, {
          body: _withCtx(({ data }) => [
            (data.type === 0)
              ? (_openBlock(), _createBlock(_component_InputNumber, {
                  key: 0,
                  modelValue: data.threshold,
                  "onUpdate:modelValue": ($event: any) => ((data.threshold) = $event),
                  locale: _unref(numberSeparators)[_unref(activeActivity).separator],
                  "max-fraction-digits": 20,
                  min: 0,
                  "allow-empty": false,
                  style: {"width":"100%"},
                  mode: "decimal"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "locale"]))
              : (_openBlock(), _createElementBlock("label", _hoisted_6, "-"))
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 2
    }, [
      (canCreate.value)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Button, {
                  onClick: _unref(addRow),
                  label: _ctx.$t('product.newLine'),
                  icon: "pi pi-plus"
                }, null, 8, ["onClick", "label"]),
                _createVNode(_component_Button, {
                  disabled: _unref(disableSubmit),
                  label: _ctx.$t('save'),
                  icon: "pi pi-save",
                  loading: _unref(loading),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(submitCreation)()))
                }, null, 8, ["disabled", "label", "loading"])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["value", "rows", "loading"])
  ], 64))
}
}

})